module.exports = __webpack_public_path__ + "static/img/icon07.5f7b45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon07.png
// module id = mqUI
// module chunks = 0